<template >
    <div class="video-error" :class="{ 'style2': isVerticalStyle }">
        <div class="live-text" v-if="liveText">{{ liveText }}</div>
        <div class="title">{{ title }}
            <img src="@/assets/images/live/playing/error_icon.png" class="icon">
        </div>
        <div class="text-group">
            <p class="text time" v-if="time">{{ time }}</p>
            <p class="text teacher" v-if="teacher">
                主讲老师：{{ teacher }}
            </p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: String,
        time: String,
        teacher: String,
        liveText: String,
        theme: { //样式控制  1横屏 2竖屏
            type: Number,
            default: 1
        }
    },
    computed: {
        // 是否竖屏样式
        isVerticalStyle() {
            return this.theme === 2
        }
    },
    data() {
        return {


        }
    },
}
</script>
<style lang="scss" scoped>
.video-error {
    @include background-image();
    background-size: 100%;
    background-position: center center;
    z-index: 999;
    background-color: #000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    background-image: url('../../assets/images/live/playing/error_backround.png');
    overflow: hidden;

    &.style2 {
        background-image: url('../../assets/images/live/playing/error_vertical_backround.png');
        z-index: 0;
        justify-content: flex-start;
        padding-top: 5rem;
        box-sizing: border-box
    }

    .live-text {
        @include margin_center;
        @include flex_center;
        width: 4.28rem;
        height: 1.17rem;
        font-size: 0.53rem;
        font-weight: 400;
        color: #FFFFFF;
        border-top: 1px solid rgba(255, 255, 255, 0.1608);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1608);
        margin-bottom: .59rem;
    }

    .title {
        max-width: 70%;
        font-size: 0.4rem;
        font-weight: 400;
        color: #FFFFFF;
        margin-bottom: .16rem;
        position: relative;

        .icon {
            position: absolute;
            top: .05rem;
            left: -.7rem;
            width: 0.48rem;
            height: 0.48rem;
            min-width: 0.48rem;
            min-height: 0.48rem;
        }
    }

    .text-group {
        display: flex;
        justify-content: center;
        font-size: 0.32rem;

        .text {
            color: rgba($color: #FFFFFF, $alpha: .7);
            margin: 0 .16rem;
        }
    }
}
</style>